import { EventName, isSnakeCaseEventName } from "analytics/catalog/events";
import { trackMixpanelEvent } from "analytics/mixpanel/client";

export const trackEvent = (
  eventName: EventName,
  props: Record<string, unknown> = {},
): void => {
  if (!isSnakeCaseEventName(eventName)) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`[analytics] Invalid event name: ${eventName}`);
    }
    return;
  }

  trackMixpanelEvent(eventName, props);
};
